import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#09090f]/95 backdrop-blur-xl border-b border-[#c9a84c]/20 shadow-[0_0_40px_rgba(201,168,76,0.08)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20 md:h-24">
          {/* Logo & Brand */}
          <div className="flex items-center space-x-3">
            <div className="relative w-12 h-12 flex items-center justify-center">
              <div className="absolute inset-0 rounded-full bg-white opacity-10 blur-md" />
              <img
                src="https://static.readdy.ai/image/d80b109f077bb32eaa0599f7baacf71d/1a1c5c0753a4462286ecfdd9164334d4.png"
                alt="Éclat-Gen Logo"
                className="relative w-12 h-12 object-contain drop-shadow-[0_0_10px_rgba(255,255,255,0.7)]"
              />
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-bold tracking-[0.12em] uppercase"
                style={{ background: 'linear-gradient(135deg, #c9a84c 0%, #f0d98a 50%, #c9a84c 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Éclat-Gen
              </h1>
              <p className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-[#c9a84c]/60 font-light -mt-0.5">
                Brilliance. Engineered.
              </p>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-white/70 hover:text-[#c9a84c] text-sm font-medium cursor-pointer transition-colors duration-300 tracking-wide"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="relative px-6 py-2.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-300 overflow-hidden group"
              style={{
                background: 'linear-gradient(135deg, #c9a84c, #e8c87a)',
                borderRadius: '4px',
                color: '#09090f',
              }}
            >
              <span className="relative z-10 font-semibold tracking-wide">Get Started</span>
              <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </a>
          </div>

          {/* Hamburger */}
          <button
            className="md:hidden text-[#c9a84c] cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#09090f]/98 backdrop-blur-xl border-t border-[#c9a84c]/20 px-4 py-6 space-y-2">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block text-white/70 hover:text-[#c9a84c] px-3 py-3 text-sm font-medium cursor-pointer tracking-wide transition-colors duration-300"
            >
              {link.label}
            </a>
          ))}
          <div className="pt-2">
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="block text-center py-3 text-sm font-semibold whitespace-nowrap cursor-pointer rounded tracking-wide"
              style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', color: '#09090f' }}
            >
              Get Started
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
